<template>
    <DxDataGrid :data-source="dsStudies" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="300" :height="390" :show-title="true" title-template="customTitleTemplate">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" /> 
            </DxPopup>
            <DxFormGrid>
                <DxItem :col-span="1" :col-count="1" item-type="group">
                    <DxItem data-field="name" :editor-options="{ width: 250, height: 50 }"/>
                    <DxItem data-field="code" :editor-options="{ width: 250, height: 50 }"/>
                    <DxItem data-field="isCourse" editor-type="dxCheckBox" :css-class="'checkbox-center'" :editor-options="{ elementAttr: { style: 'display:flex; justify-content:center;' } }">
                    </DxItem>
                </DxItem>
            </DxFormGrid>
        </DxEditing>
        <template #customTitleTemplate>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Editare Tip Studiu
            </div>
        </template>

        <DxColumn data-field="code" caption="Cod"/>
        <DxColumn data-field="name" caption="Nume"/>
        <DxColumn data-field="isCourse" caption="E curs?"/>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>                
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" height="390px" width="300px">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Tip Studiu
            </div>
        </template>
        <DxForm :col-count="1" :data-source="newStudy" label-alignment="center">
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newStudy.name" @value-changed="onNumeValueChanged"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Cod" :is-required="true">
                <template #default>
                    <DxTextArea :value="newStudy.code" @value-changed="onCodValueChanged"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="E curs?" :is-required="true">
                <template #default>
                    <div style="display: flex; justify-content: center;">
                        <DxCheckBox :value="newStudy.isCourse" @value-changed="onCourseValueChanged" />
                    </div>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem,
  DxItem as DxFormItem,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxSearchPanel,
  DxSearch
} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';
import PER_Studies from '@/services/PER/PER_Studies';

export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem
    },
    data() {
        return {
            dsStudies: {} as DataSource,
            dataGridRef: ref<DxDataGrid | null>(null),
            addPopupVisible: false,
            newStudy: {
                name: '',
                code: '',
                isCourse: false,
            },
            addButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
        }
    },
    mounted() {
        this.dsStudies = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `PER_Studies`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                },
            },
        })
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage()
    },
    methods: {
        onAddClick() {
            this.addPopupVisible = true
        },
        onCloseAdd() {
            this.addPopupVisible = false
            this.newStudy.name = ''
            this.newStudy.code = ''
            this.newStudy.isCourse = false
        },
        onSaveAdd() {
            if (!this.newStudy.name || this.newStudy.name.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 2000)
                return
            }
            if (!this.newStudy.code || this.newStudy.code.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 2000)
                return
            }
            PER_Studies.save(this.newStudy).then((studiu) => {
                this.addPopupVisible = false
                notify('Datele au fost salvate cu succes!', 'success', 2000)
                this.newStudy = {
                    name: '',
                    code: '',
                    isCourse: false
                }
                this.onRefreshClick()
            }).catch((error) => {
                console.error(error)
            })
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onNumeValueChanged(e: any) {
            this.newStudy.name = e.value
        },
        onCodValueChanged(e: any) {
            this.newStudy.code = e.value
        },
        onCourseValueChanged(e: any) {
            this.newStudy.isCourse = e.value
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return; 
            }
            try {
                gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
            }
        },
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onRefreshClick() {
            const gridInstance = this.dataGridRef?.instance;
            if (gridInstance) {
                gridInstance.refresh();
                notify("Datele au fost actualizate cu succes!", "success", 3000);
            }
        },
    }
})
</script>
<style>
.checkbox-center .dx-field-item-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 110px;
  margin-top: 30px;
}
</style>